import * as Notifications from 'expo-notifications';

export const DRIVING_STATUS_NOTIFICATION_ID = 'driving-status';
export const DRIVING_STATUS_NOTIFICATION_CATEGORY = 'driving-status-actions';
export const DRIVING_ALERT_NOTIFICATION_CATEGORY = 'driving-alert-actions';
export const MOVEMENT_ALERT_NOTIFICATION_CATEGORY = 'movement-alert-actions';

export const MOVEMENT_ALERT_NOTIFICATION_ID = 'movement-alert';
export const STATIONARY_ALERT_NOTIFICATION_ID = 'stationary-alert';

export const START_DRIVING_ACTION_ID = 'start-driving';
export const STOP_DRIVING_ACTION_ID = 'stop-driving';
export const CANCEL_NOTIFICATION_ACTION_ID = 'cancel';

export type DrivingAlertNotificationKind = 'movement' | 'stationary';

export const getDrivingAlertNotificationId = (kind: DrivingAlertNotificationKind): string =>
  kind === 'movement' ? MOVEMENT_ALERT_NOTIFICATION_ID : STATIONARY_ALERT_NOTIFICATION_ID;

const dismissAlertById = async (notificationId: string) => {
  try {
    await Notifications.dismissNotificationAsync(notificationId);
  } catch (error) {
    console.warn('Failed to dismiss driving alert notification', {
      notificationId,
      error,
    });
  }
};

export const dismissDrivingAlertNotifications = async () => {
  await Promise.all([
    dismissAlertById(MOVEMENT_ALERT_NOTIFICATION_ID),
    dismissAlertById(STATIONARY_ALERT_NOTIFICATION_ID),
  ]);
};

export const getNotificationResponseCategoryIdentifier = (response: any): string | undefined =>
  response?.notification?.request?.content?.categoryIdentifier;

export const isDrivingStatusNotificationResponse = (response: any): boolean =>
  getNotificationResponseCategoryIdentifier(response) === DRIVING_STATUS_NOTIFICATION_CATEGORY;

export const isDrivingAlertNotificationResponse = (response: any): boolean =>
  getNotificationResponseCategoryIdentifier(response) === DRIVING_ALERT_NOTIFICATION_CATEGORY;

export const isMovementAlertNotificationResponse = (response: any): boolean =>
  getNotificationResponseCategoryIdentifier(response) === MOVEMENT_ALERT_NOTIFICATION_CATEGORY;
